module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_studio_3column@3x-5dd03d94331c7a7e0021ac747491e7cd.webp";